export default __webpack_public_path__ + "static/media/log.4b991e18.svg";